<template>
  <div v-loading.body="loading">
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>筛选查询</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-col :span="24">
                <el-form :inline="true" :model="form" class="demo-form-inline">
                  <el-form-item label="输入搜索：">
                    <el-input
                      v-model="form.supply_name"
                      placeholder="商家"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.pgid"
                      placeholder="代采组"
                      filterable
                    >
                      <el-option label="全部" value="0"></el-option>
                      <el-option
                        v-for="item in search_ops.pg_list"
                        :key="item.pgid"
                        :label="item.pgname"
                        :value="item.pgid"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.pg_member_id"
                      placeholder="代采组员"
                      filterable
                    >
                      <el-option label="全部" value="0"></el-option>
                      <el-option
                        v-for="item in search_ops.memberOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select v-model="form.city" placeholder="城市">
                      <el-option
                        v-for="item in search_ops.city"
                        :key="item.key"
                        :label="item.label"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.father_market_id"
                      placeholder="一级市场"
                      filterable
                      @change="setChild"
                    >
                      <el-option
                        v-for="item in search_ops.market"
                        :key="item.key"
                        :label="item.label"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.market_id"
                      placeholder="二级市场"
                      multiple
                      filterable
                    >
                      <el-option
                        v-for="item in search_ops.child_market"
                        :key="item.key"
                        :label="item.label"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select v-model="form.swb_status" placeholder="状态">
                      <el-option label="全部" value="0"></el-option>
                      <el-option
                        v-for="item in search_ops.swb_status"
                        :key="item.key"
                        :label="item.label"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="生成日期：">
                    <el-date-picker
                      v-model="form.create_time"
                      :default-time="['00:00:00', '23:59:59']"
                      type="datetimerange"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                    >
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="search">查询</el-button>
                  </el-form-item>
                  <!--                                    <el-form-item>-->
                  <!--                                        <el-button  @click="reset">重置</el-button>-->
                  <!--                                    </el-form-item>-->
                </el-form>
              </el-col>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row v-if="!loading">
      <el-col style="border: 1px solid #ddd">
        <el-row
          :span="24"
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <el-col :span="8">数据列表：</el-col>
          <el-col :span="16" style="text-align: right">
            <el-button type="primary" style="" size="mini" @click="dabiao">
              待回货商品前置打标</el-button
            >
            <el-button type="success" style="" size="mini" @click="output">
              导出</el-button
            >
          </el-col>
        </el-row>
        <div v-if="resData" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            height="800"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              type="selection"
              width="50"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="create_day"
              label="生成日期"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="supply_id"
              label="商家ID"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="supply_name"
              label="商家"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="supply_city"
              label="城市"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="father_market"
              label="一级市场"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="market"
              label="二级市场"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="pgname"
              label="代采组"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="member"
              label="代采员"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="all_num"
              label="待回货"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="supply_wait_back_swb_status"
              label="状态"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="operator_names"
              label="打标人"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="operator_dates"
              label="打标时间"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper ,sizes"
            :total="resData.count"
            :page-size="form.pagesize"
            :page-sizes="[50, 100, 200, 500]"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchCondition();
    });
  },
  data() {
    return {
      resData: null,
      form: {
        create_time: this.searchDate(),
        pagesize: 100,
        search_type: 1,
        page: 1,
        market_id: "",
      },
      loading: false,
      url: "/erp/SupplyWaitBack/supplyWaitBackList",
      curPage: 1,
      tableLoading: false,
      filterFold: false,
      msg: "",
      search_ops: {},
      da_biao_num: 0,
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },

  created() {
    this.initWebSocket();
  },
  methods: {
    // 连接打印机
    initWebSocket() {
      // 初始化weosocket
      const ishttps = document.location.protocol == "https:";
      if (ishttps) {
        var wsuri = "wss://localhost:13529"; // https wss地址
      } else {
        var wsuri = "ws://localhost:13528"; // ws地址
      }
      this.websocket = new WebSocket(wsuri);
      this.websocket.onerror = (_) => {
        this.$alert("连接打印机错误!!!", "提示");
      };
      this.websocket.onmessage = (e) => {
        const obj = JSON.parse(e.data);
        if (obj.cmd == "print") {
          if (obj.status == "failed") {
            this.$confirm(obj.msg, "提示", {
              confirmButtonText: "重新打印",
              cancelButtonText: "取消",
              type: "warning",
            }).then(() => {
              this.doPrint(); // 第一次调用打印机的时候已经设置过print_data了 再次调用的时候不用再传数据了
            });
          } else {
            this.$message.success("打标成功");
          }
        }
      };
    },

    // 执行打印
    doPrint(print_data) {
      this.print_data = JSON.stringify(print_data);
      this.websocket.send(this.print_data);
    },

    setChild(value) {
      if (value != "0") {
        if (
          this.search_ops.allow_market_id.length > 0 &&
          !this.search_ops.allow_market_id.includes(value)
        ) {
          this.$message.error("目前只生成广深鞋包饰品的数据");
          return;
        }
        for (const key in this.search_ops.market) {
          if (value == this.search_ops.market[key].key) {
            this.search_ops.child_market = this.search_ops.market[key].children;
          }
        }
      }
    },
    handleSelectionChange(val) {
      const multipleSelection = [];
      this.da_biao_num = 0;
      for (const key in val) {
        multipleSelection[key] = val[key].swb_id;
        this.da_biao_num += parseInt(val[key].all_num);
      }
      this.form.swb_ids = multipleSelection;
    },
    handleSizeChange($val) {
      this.form.pagesize = $val;
      this.fetchData(true);
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    searchDate() {
      const endDate = new Date();
      endDate.setDate(endDate.getDate());
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()} 23:59:59`;

      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 6);
      const startM =
        startDate.getMonth() + 1 < 10
          ? `0${startDate.getMonth() + 1}`
          : startDate.getMonth() + 1;
      const start = `${startDate.getFullYear()}-${startM}-${startDate.getDate()} 00:00:00`;
      return [start, end];
    },
    dabiao() {
      this.$http
        .post("/erp/SupplyWaitBack/beforeDabiao", this.form)
        .then((res) => {
          if (res.data.code != 200) return this.$message.e(res.data.msg);
          let msg = "";
          if (res.data.data) {
            msg = `共选择${this.form.swb_ids.length}个档口,共${res.data.data.goods_num}款,${this.da_biao_num}件`;
          }
          this.$confirm(msg, "", {
            confirmButtonText: "确认",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.$http
                .post("/erp/SupplyWaitBack/dabiaoByWaitBack", this.form)
                .then((rs) => {
                  if (rs.data.code != 200) return this.$message.e(rs.data.msg);
                  // 交给打印机
                  this.doPrint(rs.data.data.print_data);
                  this.$message.success(rs.data.msg);
                  this.form.swb_ids = [];
                  this.da_biao_num = 0;
                  this.fetchData(true);
                });
            })
            .catch(() => {});
        });
    },
    output() {
      this.form.is_excel = 1;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.form.is_excel = 0;
        this.form.is_excel_detail = 0;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.loading = false;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },

    handleCurrentChange(val) {
      this.form.page = val;
      this.fetchData(true);
    },
    search() {
      this.form.page = 1;
      this.form.is_excel = 0;
      this.fetchData(true);
    },
    fetchCondition() {
      this.$http
        .post("/erp/SupplyWaitBack/getCondition", this.filteredForm)
        .then((res) => {
          this.loading = false;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.search_ops = res.data.data;
          }
        });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    reset() {
      this.form = {
        recheck_begin_time: this.searchDate(),
        page: 1,
        pagesize: 50,
        search_type: 1,
      };
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.column {
  text-align: center;
  border: 1rpx solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.tab-div {
  border: 1px solid #ddd;
  margin: 20px 0;
  padding: 10px 0 10px 20px;
}

.tag-css {
  margin-left: 10px;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.el-dropdown-menu__item {
  background-color: #f56c6c;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/supplywaitback/SupplyWaitBackList.vue